// extracted by css-extract-rspack-plugin
export default {"SnippetForm":"cenNB","FormSnippetTextArea":"HMf9U","ArchiveButton":"CxvUO"};